import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ReportHttpService } from '../http/report-http.service';

@Injectable({
    providedIn: 'root',
})
export class EndOfDayReportHttpResolverService implements Resolve<any> {
    constructor(private reportHttpService: ReportHttpService, private calendar: NgbCalendar, private ngbDateParserFormatter: NgbDateParserFormatter) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const modelFormatted = this.ngbDateParserFormatter.format(this.calendar.getToday());
        return this.reportHttpService.getEndOfDayReport(modelFormatted);
    }
}
